import React, { useEffect, useState } from "react";
import { Button } from "antd";
import Main from "../../components/layout/Main";
import TumanentImage from "../../assets/images/tunamnet-tubhnail-image.jpg";
import GamesImage from "../../assets/images/games-image.jpg";
import TrofiesImage from "../../assets/images/trofies-image.svg";
import { useNavigate } from "react-router";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useTournament } from "../../context/TournamentContext";
import moment from "moment";
import { getDiff, isValidUrl } from "../../helper/functions";
import { ImageNotAvailable } from "../../constants/urls";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { useAuth } from "../../context/AuthContext";
import { Severty, ShowToast } from "../../helper/toast";

const UpcomingTournament = () => {
  const [games, setGames] = useState([]);
  const [tournaments, setTournaments] = useState([]);
  const [profile, setProfile] = useState();
  const Navigate = useNavigate();
  const { getProfile } = useAuth();
  const { loadTournaments, filters, updateFilters, loadGames } =
    useTournament();
  // ----------   handlers   -----------
  const fetchTournaments = async (params = {}) => {
    const profileData = await getProfile();
    if (profileData.status === 200) {
      setProfile(profileData.data);
    }

    const response = await loadTournaments(params);
    if (response.status === 200) {
      setTournaments(response.data.data.tournaments);
    }
    const result = await loadGames();
    if (result.status === 200) {
      setGames(result.data.data.uncategorizedGames);
    }
  };

  // ---------- use effects ----------
  useEffect(() => {
    const params = { status: "Upcoming", type: "public" };
    updateFilters(params);
    fetchTournaments(params);
  }, []);

  return (
    <Main>
      <div className="section-headding">
        <h6>Upcoming Tournaments</h6>
        <div className="create-btn-header">
          <Button
            className="private-tunament-button Fill-button"
            onClick={() => {
              if (profile.isSubscribed) {
                Navigate("/create-private-tournament");
              } else {
                ShowToast(
                  "You can't create private tournament. Kindly subscribe our plan",
                  Severty.ERROR
                );
              }
            }}
          >
            Create Private Tournament
          </Button>
        </div>
      </div>
      <div className="home-container">
        <Section
          title="Browse by Games"
          data={games}
          type="game"
          navigate={Navigate}
          profile={profile}
        />
        <Section
          data={tournaments}
          type="tournament"
          navigate={Navigate}
          profile={profile}
        />
      </div>
    </Main>
  );
};

const Section = ({ title, data, type, navigate, profile }) => {
  // console.log("data--->", data);
  const settings = {
    dots: false,
    infinite: true,
    arrows: false,
    speed: 500,
    slidesToShow: 4, // ek time me 4 item
    slidesToScroll: 1,

    responsive: [
      {
        breakpoint: 1024, // tablet
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768, // mobile
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480, // small mobile
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div className="section-block">
      {type === "tournament" ? (
        <>
          <div className="section-header">
            <div className="orange-header">{title}</div>
          </div>
          <div className="main-grid-class">
            {data.length > 0
              ? data.map((item, index) => (
                  <div
                    key={index}
                    className="tournament-card"
                    onClick={() =>
                      navigate(
                        `/upcoming-tournaments/tournaments-details/${item._id}`
                      )
                    }
                  >
                    <div className="tunament-image">
                      <img
                        alt="thumbnail"
                        src={item.game.image || TumanentImage}
                      />
                    </div>

                    <div className="card-top-info">
                      <div className="tunament-date">
                        {moment(item.startDate).format("DD MMM YYYY | HH:mm A")}
                      </div>
                      <div className="starts-time">
                        <span>{getDiff(item.startDate, new Date())}</span>
                      </div>
                    </div>

                    <div className="card-tags">
                      <img src={TrofiesImage} alt="Trophies" />
                      <span>{item.name_en}</span>
                    </div>

                    <div className="tunament-slot">{`${
                      item.totalRegisteredPlayers
                    }/ ${
                      item?.teamSize *
                      (item.totalPlayerSize > 0 ? item.totalPlayerSize : 1)
                    } slots`}</div>

                    <div className="tunamnet-game-name-main">
                      <div className="tunamnet-game-name">
                        <h5>
                          {item.game.name} <span>{item.status}</span>
                        </h5>
                      </div>
                      {/* {profile?.isSubscribed ? (
                        <Button
                          className="join-button Fill-button"
                          onClick={() =>
                            navigate(
                              `/upcoming-tournaments/tournaments-details/${item._id}`
                            )
                          }
                        >
                          Join
                        </Button>
                      ) : (
                        <>
                          <Button
                            className="fill-button-smal"
                            onClick={(e) => {
                              e.stopPropagation();
                              navigate("/subscriptions");
                            }}
                          >
                            Upgrade To Premium
                          </Button>
                          <Button
                            className="fill-button-smal"
                            onClick={() =>
                              navigate(
                                `/upcoming-tournaments/tournaments-details/${item._id}`
                              )
                            }
                          >
                            Play via token
                          </Button>
                        </>
                      )} */}
                      <Button
                        className="join-button Fill-button"
                        onClick={() =>
                          navigate(
                            `/upcoming-tournaments/tournaments-details/${item._id}`
                          )
                        }
                      >
                        Join
                      </Button>
                    </div>
                  </div>
                ))
              : "No Upcoming Tournaments"}
          </div>
        </>
      ) : type === "game" ? (
        <>
          <div className="section-header">
            <div className="orange-header">{title}</div>
            <span
              className="view-all"
              onClick={() => navigate("/upcoming-tournaments/games")}
            >
              {data && " View All "}
            </span>
          </div>

          <div className="browse-game-slide">
            {data && data.length > 0 ? (
              <Swiper
                modules={[Navigation]}
                navigation={true}
                loop={true}
                speed={500}
                spaceBetween={20}
                breakpoints={{
                  480: { slidesPerView: 1 },
                  768: { slidesPerView: 2 },
                  1024: { slidesPerView: 3 },
                  1200: { slidesPerView: 4 },
                }}
              >
                {data.map((item, index) => (
                  <SwiperSlide key={index}>
                    <div
                      className="game-card"
                      // onClick={() => navigate("/upcoming-tournaments/games")}
                      onClick={() =>
                        navigate(
                          `/upcoming-tournaments/games/${item?.game?.name}?tab=Upcoming`
                        )
                      }
                    >
                      <img
                        src={
                          isValidUrl(item.game.image)
                            ? item.game.image
                            : ImageNotAvailable
                        }
                        alt="Game"
                        className="game-image"
                      />

                      <div className="card-top-info">
                        <div className="tunament-date">{item.game.name}</div>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            ) : (
              <div className="no-games-available">
                <p>No games available</p>
              </div>
            )}
          </div>
        </>
      ) : null}
    </div>
  );
};

export default UpcomingTournament;
